import { LegalLayout, LegalSection } from "@/components/LegalLayout";

export default function Datenschutz() {
    return (
        <LegalLayout title="Datenschutzerklärung" updated="Stand: Juli 2026" testid="datenschutz-page">
            <LegalSection title="1. Verantwortlicher" testid="datenschutz-section-controller">
                <p>
                    Verantwortlicher im Sinne der DSGVO ist:
                    <br />
                    Kirenzo, Inhaber: Wassim Acharkaoui, Kleine Steinstr. 14, 45128 Essen, Deutschland
                    <br />
                    E-Mail:{" "}
                    <a href="mailto:info@kirenzo.de" className="text-emerald-400 hover:text-emerald-300 underline underline-offset-4">
                        info@kirenzo.de
                    </a>
                </p>
            </LegalSection>
            <LegalSection title="2. Allgemeines zur Datenverarbeitung" testid="datenschutz-section-general">
                <p>
                    Wir verarbeiten personenbezogene Daten nur, soweit dies für den Betrieb dieser Website,
                    die Beantwortung von Anfragen oder die Erfüllung gesetzlicher Pflichten erforderlich ist
                    (Art. 6 Abs. 1 lit. b und f DSGVO). Eine Weitergabe Ihrer Daten an Dritte zu
                    Werbezwecken findet nicht statt.
                </p>
            </LegalSection>
            <LegalSection title="3. Hosting und Server-Logfiles" testid="datenschutz-section-hosting">
                <p>
                    Diese Website wird bei einem Hosting-Dienstleister betrieben. Beim Aufruf der Seiten
                    werden automatisch technische Daten verarbeitet (z.&nbsp;B. IP-Adresse, Datum und Uhrzeit
                    des Zugriffs, Browsertyp). Diese Daten sind technisch notwendig, um die Website
                    auszuliefern und ihre Sicherheit zu gewährleisten (Art. 6 Abs. 1 lit. f DSGVO). Die
                    Server stehen in Deutschland bzw. der Europäischen Union.
                </p>
            </LegalSection>
            <LegalSection title="4. Kontaktaufnahme per E-Mail" testid="datenschutz-section-contact">
                <p>
                    Wenn Sie uns per E-Mail kontaktieren (z.&nbsp;B. über die Demo-Buttons auf dieser Seite),
                    verarbeiten wir Ihre E-Mail-Adresse und die Inhalte Ihrer Nachricht, um Ihre Anfrage zu
                    beantworten (Art. 6 Abs. 1 lit. b DSGVO). Die Daten werden gelöscht, sobald sie für den
                    Zweck nicht mehr erforderlich sind und keine gesetzlichen Aufbewahrungspflichten
                    bestehen.
                </p>
            </LegalSection>
            <LegalSection title="5. Reichweitenmessung" testid="datenschutz-section-analytics">
                <p>
                    Diese Website kann eine technisch eingebundene Reichweitenmessung der Hosting-Plattform
                    enthalten, mit der wir die Nutzung der Seite anonym auswerten, um sie zu verbessern
                    (Art. 6 Abs. 1 lit. f DSGVO). Es werden dabei keine Profile zu Werbezwecken erstellt und
                    keine Daten an Werbenetzwerke übergeben.
                </p>
            </LegalSection>
            <LegalSection title="6. Ihre Rechte" testid="datenschutz-section-rights">
                <p>
                    Sie haben das Recht auf Auskunft (Art. 15 DSGVO), Berichtigung (Art. 16 DSGVO), Löschung
                    (Art. 17 DSGVO), Einschränkung der Verarbeitung (Art. 18 DSGVO), Datenübertragbarkeit
                    (Art. 20 DSGVO) sowie Widerspruch gegen die Verarbeitung (Art. 21 DSGVO). Zudem besteht
                    ein Beschwerderecht bei der zuständigen Datenschutz-Aufsichtsbehörde.
                </p>
                <p>
                    Für alle Fragen zum Datenschutz genügt eine formlose E-Mail an{" "}
                    <a href="mailto:info@kirenzo.de" className="text-emerald-400 hover:text-emerald-300 underline underline-offset-4">
                        info@kirenzo.de
                    </a>
                    .
                </p>
            </LegalSection>
            <LegalSection title="7. Aktualität dieser Erklärung" testid="datenschutz-section-updates">
                <p>
                    Wir passen diese Datenschutzerklärung an, sobald sich die Verarbeitung auf dieser Website
                    ändert oder Rechtsänderungen dies erfordern. Die jeweils aktuelle Version finden Sie an
                    dieser Stelle.
                </p>
            </LegalSection>
        </LegalLayout>
    );
}
